import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../../components/Layout';
import Loading from '../../../components/Loading';
import Error from '../../../components/Error';
import TourList from './TourList';

const propTypes = {
  tours: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tagline: PropTypes.string,
    image: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
    created_on: PropTypes.string,
    updated_on: PropTypes.string,
    state: PropTypes.string.required,
    sent_to_manager: PropTypes.string,
    travel_agency: PropTypes.number,
    notes: PropTypes.arrayOf(PropTypes.object),
  })).isRequired,
  tourStateFilter: PropTypes.object.isRequired,
  selectTour: PropTypes.func.isRequired,
  requestTours: PropTypes.func.isRequired,
  requestTourManagers : PropTypes.func.isRequired,
  requestTour: PropTypes.func.isRequired,
  addTour: PropTypes.func.isRequired,
  tourFilterSet: PropTypes.func.isRequired,
  isTourManager: PropTypes.bool.isRequired,
};

class Tours extends React.Component {

  componentDidMount() {
    if (!this.props.id && this.props.needFetch) {
      // do not get all tours when loading detail
      this.props.requestTours();
    } else if (this.props.id && this.props.selectedTour.needFetch) {
      this.props.requestTour(this.props.id);
    }
    // this.props.requestTourManagers();
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id) {
      if (nextProps.id) {
        this.props.selectTour(nextProps.id);
      } else if (nextProps.needFetch) {
        this.props.requestTours();
      }
    } else if (nextProps.id && nextProps.selectedTour.needFetch) {
      this.props.requestTour(nextProps.id);
    }
  }
  renderDetail() {
    if (this.props.selectedTour.isFetching || this.props.selectedTour.needFetch) {
      return (
        <Layout>
          <Loading />
        </Layout>
      );
    }
    if (this.props.selectedTour.hasError) {
      return (
        <Layout>
          <Error />
        </Layout>
      );
    }
    return (
      <Layout>
        <div>
          {this.props.children}
        </div>
      </Layout>
    );
  }
  renderList() {
    if (this.props.needFetch || this.props.isFetching) {
      return (
        <Layout>
          <div className="content-tours">
            <div className="container-fluid">
              <div className="row tour-head">
                <div className="col-xs-6 col-sm-6 col-md-6 tour-headText">
                  <h2>Travel</h2>
                  <hr />
                </div>
              </div>
              <div className="row">
                <Loading />
              </div>
            </div>
          </div>
        </Layout>
      );
    }
    return (
      <Layout>
        <div className="content-tours">
          <TourList
            tours={this.props.tours}
            addTour={this.props.addTour}
            editTour={this.props.addTour}
            isTourManager={this.props.isTourManager}
            filter={this.props.tourStateFilter}
            tourFilterSet={this.props.tourFilterSet}
            requestTourManagers = {this.props.requestTourManagers}
            tourManagers = {this.props.tourManagers}
          />
        </div>
      </Layout>
    );
  }
  render() {
    if (!this.props.id) {
      return this.renderList();
    }
    return this.renderDetail();
  }
}

Tours.propTypes = propTypes;
Tours.defaultProps = {
  tours: [],
};

export default Tours;



// WEBPACK FOOTER //
// src/routes/tours/components/Tours.js